import { $, DatePicker } from '@starberry/components';

export default {
  $: 'Dashboard',
  title: 'Calendar',
  content: [
    {
      $: '2Column',
      props: {
        templateColumns: { base: 'repeat(12, 1fr)' },
      },
      leftColumnProps: {
        colSpan: { base: 12, xl: 6, '2xl': 8 },
      },
      rightColumnProps: {
        colSpan: { base: 12, xl: 6, '2xl': 4 },
      },
      leftColumn: [
        {
          $: 'Stack',
          props: { direction: 'column' },
          children: {
            $: 'PendingActions',
            hideTitle: true,
          },
        },
      ],
      rightColumn: [
        {
          $: 'Stack',
          props: { direction: 'column', spacing: 10 },
          children: [
            {
              $: 'RoundedCard',
              props: {
                justifyContent: 'center',
              },
              content: [
                {
                  $: 'MonthSelector',
                  provide: ['datepicker'],
                  props: {
                    focusedMonth: (_, context) => {
                      return context?.state?.datepicker?.[0].focusedMonth ?? new Date();
                    },
                    onNextMonth: (_, context) => (date) =>
                      context?.state?.datepicker?.[1]({
                        type: 'FOCUS_MONTH',
                        payload: date,
                      }),
                    onPrevMonth: (_, context) => (date) =>
                      context?.state?.datepicker?.[1]({
                        type: 'FOCUS_MONTH',
                        payload: date,
                      }),
                  },
                },
                {
                  component: DatePicker,
                  provide: ['datepicker'],
                  props: {
                    focusedMonth: (_, context) =>
                      context?.state?.datepicker?.[0].focusedMonth ?? new Date(),
                    onSelectDay: (_, context) => (date) =>
                      context?.state?.datepicker?.[1]({
                        type: 'SELECT_DATE',
                        payload: date,
                      }),
                  },
                },
              ],
            },
            {
              $: 'RoundedCard',
              content: [
                {
                  $: 'Text',
                  props: {
                    fontSize: 20,
                  },
                  children: $('constants.texts.CALENDAR_VALUE_PROPERTY', 'Value my property'),
                },
                {
                  $: 'Text',
                  props: {
                    color: 'gray.700',
                  },
                  children: $(
                    'constants.texts.CALENDAR_BOOK_VALUATION',
                    'Book a valuation from one of our property experts.'
                  ),
                },
                { $: 'ValuationButton' },
              ],
            },
          ],
        },
      ],
    },
  ],
};

// modules: {
//   root: {
//     $: 'Stack',
//     props: {
//       width: '315px',
//     },
//     children: [
//       {
//         component: MonthSelector,
//         provide: ['datepicker'],
//         props: {
//           focusedMonth: (_, context) => {
//             return context?.state?.datepicker?.[0].focusedMonth ?? new Date();
//           },
//           onNextMonth: (_, context) => (date) =>
//             context?.state?.datepicker?.[1]({
//               type: 'FOCUS_MONTH',
//               payload: date,
//             }),
//           onPrevMonth: (_, context) => (date) =>
//             context?.state?.datepicker?.[1]({
//               type: 'FOCUS_MONTH',
//               payload: date,
//             }),
//         },
//       },
//       {
//         component: DatePicker,
//         provide: ['datepicker'],
//         props: {
//           focusedMonth: (_, context) =>
//             context?.state?.datepicker?.[0].focusedMonth ?? new Date(),
//           onSelectDay: (_, context) => (date) =>
//             context?.state?.datepicker?.[1]({
//               type: 'SELECT_DATE',
//               payload: date,
//             }),
//         },
//       },
//       {
//         $: 'Heading',
//         provide: ['datepicker'],
//         children: (_, context) =>
//           format(
//             context?.state?.datepicker?.[0].selectedDate ?? new Date(),
//             'dd/MM/yyyy'
//           ),
//       },
//     ],
//   },
// },
// };
